
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './authorizedRepresentatives_row.html?raw';
import _LabelInputBase from '../../../moreCore/UI/_LabelInputBase/_LabelInputBase';

import Edit from '../../../moreCore/UI/Edit/Edit';
import '../../../moreCore/UI/Edit/Edit';


interface _value {
    firstName: string;
    preposition: string;
    surname: string;
    function: string;
}
class authorizedRepresentatives_row extends compose(_LabelInputBase) {
    templateString: any = template;

    firstName_container: HTMLElement;
    preposition_container: HTMLElement;
    surname_container: HTMLElement;
    function_container: HTMLElement;

    firstName: MdsLax<InstanceType<typeof Edit>>;
    preposition: MdsLax<InstanceType<typeof Edit>>;
    surname: MdsLax<InstanceType<typeof Edit>>;
    function: MdsLax<InstanceType<typeof Edit>>;

    mandataoryFields: any = [];

    _value: _value = {
        firstName: null,
        preposition: null,
        surname: null,
        function: null
    }; 

    setMandatoryFields(fields: Array<string>): void {
        this.mandataoryFields = fields;
    }

    _onChange_firstName(): void {
        this._value.firstName = this.firstName.getValue();
        this._onChange();
    }

    _onChange_preposition(): void {
        this._value.preposition = this.preposition.getValue();
        this._onChange();
    }

    _onChange_surname(): void {
        this._value.surname = this.surname.getValue();
        this._onChange();
    }

    _onChange_function(): void {
        this._value.function = this.function.getValue();
        this._onChange();
    }

    _onChange(): void {
        if (this.dataCompletnessCheck()) {
            this.emit("rowValueChange", this);
        }

    }

    validateInput(): boolean {
        return this.dataCompletnessCheck();
    }

    dataCompletnessCheck(): boolean {

        let result:boolean = true;
        let mandatoryKeys = this.mandataoryFields;

        if (mandatoryKeys.length) {
            for (let i = 0; i < mandatoryKeys.length; i++) {

                let valueProperty: string = mandatoryKeys[i];

                this[valueProperty].validateInput();

                if (!this._value.hasOwnProperty(valueProperty) || this._value[valueProperty] == null || this._value[valueProperty] == "") {
                    result = false;
                    console.log("missing property: ", mandatoryKeys[i]);
                } 
            }
        } else {
            result = true;
        }

        return result;
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(authorizedRepresentatives_row);